import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	height: 40px;
	user-select: none;

	> div {
		font-family: 'GT Walsheim Pro';
		color: #fff;

		&:first-child {
			position: absolute;
			top: -3px;
			left: 0;
			height: 30px;
			font-size: 26px;
			font-weight: 900;
			text-transform: uppercase;
		}

		&:last-child {
			position: absolute;
			bottom: -5px;
			left: 0;
			height: 18px;
			font-size: 16px;
			opacity: 0.5;
		}
	}
`;

export { StyledContainer };
